import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import noteTaking from "../assets/img/note-taking.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import cryptoDashboard from "../assets/img/crypto-dashboard.png";
import crispNewsImg from "../assets/img/CrispNews.png";
import yTsubscribers from "../assets/img/Youtube-subsribers.png";
import GoerliMons from "../assets/img/Goerli-mons.png";
import UniswapV3Img from "../assets/img/uniswapV3.png";
import SmartContract from "../assets/img/smart-contract.png";
import busBooking from "../assets/img/Bus-booking.png";
import scrapper from "../assets/img/Scrapper.png";

import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Crypto Currency Dashboard",
      description: "A comprehensive dashboard that gives real time data and price of various crypto currencies",
      imgUrl: cryptoDashboard,
      url: "https://github.com/basu1020/Crypto-Currency-Dashboard"
    },
    {
      title: "Crisp News Website",
      description: "A clone of popular website 'Inshorts' that gives you quick news bites, made with ReactJS",
      imgUrl: crispNewsImg,
      url:"https://github.com/basu1020/CrispNews-WebApp"
    },
    {
      title: "Personal Note Taker",
      description: "A complete MERN stack app with authentication features using JSON Web-Token and bcryptJS for taking your personal notes.",
      imgUrl: noteTaking,
      url: "https://github.com/basu1020/Notebook-App"
    },
    {
      title: "Bus Booking Website",
      description: "A complete MERN stack project to book buses for intercity travel",
      imgUrl: busBooking,
      url: "https://github.com/basu1020/BusBookingProject"
    },
    {
      title: "Get Youtube Subscribers",
      description: "API made with NodeJS, ExpressJS and MongoDB to give subscribers data",
      imgUrl: yTsubscribers,
      url: "https://github.com/basu1020/Youtube-subscribers-Backend-Project"
    },

    {
      title: "Laptop Web Scraper",
      description: "Web scrapper that extracts gaming laptop's information from popular companies like HP, Dell, Lenovo",
      imgUrl: scrapper,
      url: "https://github.com/basu1020/Scraping-Laptops-info"
    },

    {
      title: "GoerliMon NFT Minter",
      description: "NFT minting project that mints Goerlimons NFTs on Goerli Test Network",
      imgUrl: GoerliMons,
      url: "https://github.com/basu1020/GOERLIMONS-NFT-Minter"
    },
    {
      title: "Uniswap V3 Clone",
      description: "A clone of popular Defi protocol Uniswap that lets you swap crypto-currencies on Goerli Test network.",
      imgUrl: UniswapV3Img,
      url: "https://github.com/basu1020/Uniswap_v3_Clone"
    },

    {
      title: "Smart Contracts",
      description: "Smart contracts to implement Lottery and Multi-sig Wallet on ethereum blockchain.",
      imgUrl: SmartContract,
      url: "https://github.com/basu1020/Smart-Contracts"
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Projects</h2>
                  <p> Welcome to my portfolio section! Here are some of the exciting projects I've worked on to explore the ever-evolving world of web development and blockchain </p>
                  <Row>
                    {
                      projects.map((project, index) => {
                        return (
                      
                            <ProjectCard
                              key={index}
                              {...project}
                            />
                        )
                      })
                    }
                  </Row>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="Image"></img>
    </section>
  )
}
